import { render, staticRenderFns } from "./AddFromMarketButton.vue?vue&type=template&id=9a9fe25a&scoped=true&"
import script from "./AddFromMarketButton.vue?vue&type=script&lang=js&"
export * from "./AddFromMarketButton.vue?vue&type=script&lang=js&"
import style0 from "./AddFromMarketButton.vue?vue&type=style&index=0&id=9a9fe25a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9fe25a",
  null
  
)

export default component.exports